// extracted by mini-css-extract-plugin
export const search = "styles-module--search--f07SJ";
export const searchBar = "styles-module--searchBar--Ntv4i";
export const searchBarReadOnly = "styles-module--searchBarReadOnly--o9rXJ";
export const searchIcon = "styles-module--searchIcon--+6zni";
export const searchLocation = "styles-module--searchLocation--dOACR";
export const btn = "styles-module--btn--5-SIG";